<!--
~ Ki-Tax: System for the management of external childcare subsidies
~ Copyright (C) 2017 City of Bern Switzerland
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as
~ published by the Free Software Foundation, either version 3 of the
~ License, or (at your option) any later version.
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. If not, see <http://www.gnu.org/licenses/>.
-->

<div class="zahlungsauftrag-view">
    <!-- Toggle fuer den Auszahlungstyp (anstelle von Tabs, da GUI sonst identisch) -->
    @if (showAuszahlungsTypToggle()) {
        <div class="switch-auszahlungstyp">
            <dv-switch
                [switchOptionLeft]="'GEMEINDE_INSTITUTION'"
                [switchOptionRight]="'GEMEINDE_ANTRAGSTELLER'"
                [switchOptionLabelRight]="getMsgKeyForToggleRight()"
                [(switchValue)]="zahlungslaufTyp"
                (switchValueChange)="toggleAuszahlungslaufTyp()"
            ></dv-switch>
        </div>
    }

    @if (showForm()) {
        <lib-zahlung-ui-zahlungslauf-erstellen
            [settings]="{
                testMode: testMode,
                checkboxAuszahlungInZukunft: checkboxAuszahlungInZukunft,
                hasMahlzeitenZahlungslaeufe: hasMahlzeitenZahlungslaeufe
            }"
            [gemeindenList]="gemeindenList"
            [zahlungslaufTyp]="zahlungslaufTyp"
            (zahlungslaufErstellen)="updateZahlungsauftrag$.next()"
        ></lib-zahlung-ui-zahlungslauf-erstellen>
    }

    <div class="row">
        @if (zahlungslaufTyp === TSZahlungslaufTyp.GEMEINDE_INSTITUTION) {
            <div class="col-md-12">
                <h2 translate>GEMEINDE_INSTITUTION</h2>
            </div>
        }
    </div>

    <div class="row">
        @if (
            !hasMahlzeitenZahlungslaeufe &&
            this.zahlungslaufTyp === TSZahlungslaufTyp.GEMEINDE_ANTRAGSTELLER
        ) {
            <div class="col-md-12">
                <h2 translate>GEMEINDE_ANTRAGSTELLER</h2>
            </div>
        }
    </div>

    <div class="row">
        @if (
            hasMahlzeitenZahlungslaeufe &&
            this.zahlungslaufTyp === TSZahlungslaufTyp.GEMEINDE_ANTRAGSTELLER
        ) {
            <div class="col-md-12">
                <h2 translate>GEMEINDE_MAHLZEITENVERGUENSTIGUNGEN</h2>
            </div>
        }
    </div>

    <div class="row">
        <div class="col-md-12" ng-show="showInfotext()">
            <p translate>ZAHLUNGSLAUF_INFO_1</p>
            <p translate>ZAHLUNGSLAUF_INFO_2</p>
        </div>
    </div>

    <div class="row">
        <div class="col-md-11">
            <h3 translate>ZAHLUNGSAUFTRAEGE</h3>
        </div>
        <div class="col-md-1 text-right">
            <h3>{{ totalResult }}</h3>
        </div>
    </div>
    @if (showGemeindeFilter()) {
        <div class="table-responsive">
            <table class="table ebegu-table fixedtable table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>
                            <div class="dv-select-style">
                                <select
                                    name="gemeindeFilter"
                                    [(ngModel)]="filterGemeinde"
                                    (ngModelChange)="
                                        updateZahlungsauftrag$.next()
                                    "
                                >
                                    <option [ngValue]="null" selected>
                                        {{ 'ALLE' | translate }}
                                    </option>
                                    @for (
                                        gemeindeItem of gemeindenList;
                                        track gemeindeItem
                                    ) {
                                        <option [ngValue]="gemeindeItem">
                                            {{ gemeindeItem.name }}
                                        </option>
                                    }
                                </select>
                            </div>
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
            </table>
        </div>
    }
    @if (datasource) {
        <div class="dv-table dv-simple-table table-striped">
            <div class="mat-elevation-z0">
                <mat-table
                    matSort
                    (matSortChange)="sortData($event)"
                    [matSortActive]="'datumFaellig'"
                    [matSortDirection]="'asc'"
                    [dataSource]="datasource"
                >
                    @for (column of tableColumns; track column) {
                        <ng-container [matColumnDef]="column.attributeName">
                            <mat-header-cell
                                [mat-sort-header]="column.attributeName"
                                *matHeaderCellDef
                                class="ellipsis"
                            >
                                <span>{{
                                    column.displayedName | translate
                                }}</span>
                            </mat-header-cell>
                            <mat-cell
                                *matCellDef="let element"
                                class="ellipsis pointer-cursor"
                                (click)="gotoZahlung(element)"
                                [class.disabled-row]="isDisabled(element)"
                            >
                                <span
                                    [title]="
                                        getDisplayValue(element, column)
                                            | translate
                                    "
                                    [innerHTML]="
                                        getDisplayValue(element, column)
                                            | translate
                                    "
                                ></span>
                            </mat-cell>
                        </ng-container>
                    }
                    <ng-container [matColumnDef]="'betragTotalAuftrag'">
                        <mat-header-cell *matHeaderCellDef class="ellipsis">
                            <span translate>ZAHLUNG_TOTAL</span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            @if (element.hasNegativeZahlungen) {
                                <i
                                    class="fa fa-exclamation-triangle warning-negative-zahlungen"
                                    [title]="
                                        zahlungslaufTyp ===
                                        'GEMEINDE_INSTITUTION'
                                            ? ('TOOLTIP_NEGATIVE_WERTE_INSTITUTIONEN'
                                              | translate)
                                            : ('TOOLTIP_NEGATIVE_WERTE_ANTRAGSSTELLENDE'
                                              | translate)
                                    "
                                ></i>
                            }
                            <span [title]="element.betragTotalAuftrag">{{
                                element.betragTotalAuftrag | currency: '' : ''
                            }}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'zahlungPain'">
                        <mat-header-cell *matHeaderCellDef class="ellipsis">
                            <span
                                [innerHTML]="'ZAHLUNG_PAIN001' | translate"
                            ></span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            <dv-loading-button
                                type="button"
                                [buttonDisabled]="isDisabled(element)"
                                (buttonClick)="downloadPain(element)"
                                [buttonClass]="'dv-btn-operation'"
                            >
                                <i
                                    class="fa fa-lg fa-file-code-o"
                                    [class.disabled-icon]="isDisabled(element)"
                                ></i>
                            </dv-loading-button>
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'zahlungInfoma'">
                        <mat-header-cell *matHeaderCellDef class="ellipsis">
                            <span
                                [innerHTML]="'ZAHLUNG_INFOMA' | translate"
                            ></span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            @if (element.gemeinde.infomaZahlungen) {
                                <dv-loading-button
                                    type="button"
                                    [buttonDisabled]="isDisabled(element)"
                                    (buttonClick)="downloadInfoma(element)"
                                    [buttonClass]="'dv-btn-operation'"
                                >
                                    <i
                                        class="fa fa-lg fa-file-code-o"
                                        [class.disabled-icon]="
                                            isDisabled(element)
                                        "
                                    ></i>
                                </dv-loading-button>
                            }
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'zahlungPainExcel'">
                        <mat-header-cell *matHeaderCellDef class="ellipsis">
                            <span translate>ZAHLUNG_DETAILPOSITIONEN</span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            <dv-loading-button
                                type="button"
                                [buttonDisabled]="isDisabled(element)"
                                (buttonClick)="downloadAllDetails(element)"
                                [buttonClass]="'dv-btn-operation'"
                                data-test="ExcelDownloadButton"
                            >
                                <i
                                    class="fa fa-lg fa-file-code-o"
                                    [class.disabled-icon]="isDisabled(element)"
                                ></i>
                            </dv-loading-button>
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'editSave'">
                        <mat-header-cell *matHeaderCellDef class="ellipsis">
                            <span translate></span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            @if (
                                isEditable(element.status) &&
                                !isEditMode(element.id)
                            ) {
                                <dv-loading-button
                                    type="button"
                                    (buttonClick)="edit(element)"
                                    [buttonClass]="'dv-btn-operation'"
                                    data-test="editZahlungsauftrag"
                                >
                                    <i class="fa fa-lg fa-pencil-square-o"></i>
                                </dv-loading-button>
                            }
                            @if (isEditMode(element.id) && isEditValid()) {
                                <dv-loading-button
                                    type="button"
                                    (buttonClick)="save()"
                                    [buttonClass]="'dv-btn-operation'"
                                    data-test="saveZahlungsauftrag"
                                >
                                    <i class="fa fa-lg fa-floppy-o"></i>
                                </dv-loading-button>
                            }
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'datumFaellig'">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="ellipsis"
                            [mat-sort-header]="'datumFaellig'"
                        >
                            <span translate>ZAHLUNG_FAELLIGKEIT</span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            @if (isEditMode(element.id)) {
                                <div class="form-group">
                                    <label
                                        class="md-no-float"
                                        for="faelligkeitsdatumRow"
                                        translate
                                        >ZAHLUNG_GENERIERT</label
                                    >
                                    <input
                                        class="dv-mat-datepicker datepicker-edit"
                                        type="text"
                                        name="faelligkeitsdatumRow"
                                        id="faelligkeitsdatumRow"
                                        [(ngModel)]="
                                            zahlungsauftragToEdit.datumFaellig
                                        "
                                        [matDatepicker]="faelligkeitsdatumRow"
                                        required
                                    />
                                    <mat-datepicker-toggle
                                        class="datepicker-toggle-edit"
                                        matSuffix
                                        [for]="faelligkeitsdatumRow"
                                    ></mat-datepicker-toggle>
                                    <mat-datepicker
                                        #faelligkeitsdatumRow
                                    ></mat-datepicker>
                                    <div
                                        ng-messages="vm.form.faelligkeitsdatumRow.$error"
                                        role="alert"
                                        class="error"
                                    ></div>
                                </div>
                            }
                            <!-- datumFaellig -->
                            @if (!isEditMode(element.id)) {
                                <div
                                    (click)="gotoZahlung(element)"
                                    class="pointer-cursor full-width-heigth"
                                >
                                    <span
                                        [attr.title]="
                                            element.datumFaellig.format(
                                                'DD.MM.YYYY'
                                            )
                                        "
                                    >
                                        {{
                                            element.datumFaellig.format(
                                                'DD.MM.YYYY'
                                            )
                                        }}
                                    </span>
                                </div>
                            }
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'beschrieb'">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="ellipsis"
                            [mat-sort-header]="'beschrieb'"
                        >
                            <span translate>ZAHLUNG_BESCHRIEB</span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            @if (isEditMode(element.id)) {
                                <div class="form-group">
                                    <label
                                        class="md-no-float"
                                        for="beschriebRow"
                                        translate
                                        >BESCHRIEB</label
                                    >
                                    <input
                                        type="text"
                                        name="beschriebRow"
                                        id="beschriebRow"
                                        [(ngModel)]="
                                            zahlungsauftragToEdit.beschrieb
                                        "
                                        data-test="zahlungsauftragBeschrieb"
                                        required
                                    />
                                    <div
                                        ng-messages="vm.form.faelligkeitsdatumRow.$error"
                                        role="alert"
                                        class="error"
                                    ></div>
                                </div>
                            }
                            <!-- datumFaellig -->
                            @if (!isEditMode(element.id)) {
                                <div
                                    (click)="gotoZahlung(element)"
                                    class="pointer-cursor full-width-heigth"
                                >
                                    <span [attr.title]="element.beschrieb">
                                        {{ element.beschrieb }}
                                    </span>
                                </div>
                            }
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'ausloesen'">
                        <mat-header-cell *matHeaderCellDef class="ellipsis">
                            <span translate></span>
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let element"
                            class="ellipsis"
                            [class.disabled-row]="isDisabled(element)"
                        >
                            <td class="symbol text-center">
                                @if (
                                    isEditable(element.status) &&
                                    !isEditMode(element.id)
                                ) {
                                    <dv-loading-button
                                        type="button"
                                        (buttonClick)="ausloesen(element.id)"
                                        [buttonClass]="'dv-btn-operation'"
                                        data-test="ausloesen"
                                    >
                                        <i
                                            class="fa fa-lg fa-arrow-right"
                                            style="color: green"
                                        ></i>
                                    </dv-loading-button>
                                }
                            </td>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row
                        *matHeaderRowDef="getColumnsAttributeName()"
                    ></mat-header-row>
                    <mat-row
                        *matRowDef="
                            let element;
                            columns: getColumnsAttributeName()
                        "
                    ></mat-row>
                </mat-table>
                <mat-paginator [pageSize]="PAGE_SIZE"></mat-paginator>
                <div class="bottom-pagination">
                    <nav>
                        <ul class="pagination">
                            @for (index of paginationItems; track index) {
                                <li [ngClass]="{active: index - 1 === page}">
                                    <a
                                        (click)="
                                            handlePagination({
                                                pageIndex: index - 1
                                            })
                                        "
                                        >{{ index }}</a
                                    >
                                </li>
                            }
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    }
</div>
